(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-stats"] && !Shopify.designMode) return;
  try {
    
  class AboutStatsCounter extends HTMLElement {
    constructor() {
      super();
      this.animated = false;
    }

    connectedCallback() {
      this.numbers = this.querySelectorAll('[data-target]');
      this.duration = parseInt(this.dataset.duration, 10) || 2000;

      this.setupIntersectionObserver();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    setupIntersectionObserver() {
      if (!window.IntersectionObserver) {
        this.startAnimation();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.animated) {
              this.animated = true;
              this.startAnimation();
              this.observer.disconnect();
            }
          });
        },
        {
          threshold: 0.3,
          rootMargin: '0px 0px -50px 0px',
        }
      );

      this.observer.observe(this);
    }

    startAnimation() {
      this.numbers.forEach((element) => {
        this.animateNumber(element);
      });
    }

    /**
     * Animate a number from 0 to target value
     * @param {HTMLElement} element
     */
    animateNumber(element) {
      const target = parseInt(element.dataset.target, 10);
      if (isNaN(target)) return;

      const startTime = performance.now();
      const duration = this.duration;

      const update = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // Ease-out cubic for natural deceleration
        const eased = 1 - Math.pow(1 - progress, 3);

        const current = Math.floor(target * eased);
        element.textContent = current;

        if (progress < 1) {
          requestAnimationFrame(update);
        } else {
          // Ensure we end at exact target value
          element.textContent = target;
        }
      };

      requestAnimationFrame(update);
    }
  }

  if (!customElements.get('about-stats-counter')) {
    customElements.define('about-stats-counter', AboutStatsCounter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chat-widget"] && !Shopify.designMode) return;
  try {
    
  class ChatWidget extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.chat-widget__button');
      this.modal = this.querySelector('.chat-widget__modal');
      this.closeButtons = this.querySelectorAll('[data-chat-close]');
      this.bindEvents();
    }

    bindEvents() {
      this.button.addEventListener('click', this.toggle.bind(this));
      this.closeButtons.forEach((btn) => {
        btn.addEventListener('click', this.close.bind(this));
      });
      document.addEventListener('keydown', this.handleKeyDown.bind(this));
    }

    toggle() {
      const isOpen = this.modal.getAttribute('aria-hidden') === 'false';
      if (isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.modal.setAttribute('aria-hidden', 'false');
      this.button.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.modal.setAttribute('aria-hidden', 'true');
      this.button.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      this.button.focus();
    }

    handleKeyDown(event) {
      if (event.key === 'Escape' && this.modal.getAttribute('aria-hidden') === 'false') {
        this.close();
      }
    }
  }

  if (!customElements.get('chat-widget')) {
    customElements.define('chat-widget', ChatWidget);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form-tabs"] && !Shopify.designMode) return;
  try {
    
  class ContactFormTabs extends HTMLElement {
    constructor() {
      super();
      this.API_URL = 'https://uz-store-form-submission-503372ee7e06.herokuapp.com/api/contact';
      this.isSubmitting = false;
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll('.contact-form-tabs__tab');
      this.categoryInput = this.querySelector('input[name="contact[category]"]');
      this.form = this.querySelector('.contact-form-tabs__form');

      this.setupTabs();
      this.setupFormSubmission();
    }

    setupTabs() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectTab(index));

        tab.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            const nextIndex = (index + 1) % this.tabs.length;
            this.selectTab(nextIndex);
            this.tabs[nextIndex].focus();
          } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            const prevIndex = (index - 1 + this.tabs.length) % this.tabs.length;
            this.selectTab(prevIndex);
            this.tabs[prevIndex].focus();
          }
        });
      });
    }

    selectTab(index) {
      this.tabs.forEach((tab, i) => {
        const isSelected = i === index;
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');
      });

      const selectedTab = this.tabs[index];
      if (selectedTab && this.categoryInput) {
        this.categoryInput.value = selectedTab.dataset.category;
      }
    }

    setupFormSubmission() {
      if (!this.form) return;

      this.form.addEventListener('submit', async (e) => {
        if (this.isSubmitting) return;

        if (!this.form.checkValidity()) {
          e.preventDefault();
          this.form.reportValidity();
          return;
        }

        e.preventDefault();
        this.isSubmitting = true;
        this.clearMessages();

        const formData = this.collectFormData();
        const sent = await this.submitToAPI(formData);
        if (sent) {
          this.showMessage('success');
          this.form.reset();
          this.syncCategoryWithSelectedTab();
        } else {
          this.showMessage('error');
        }

        this.isSubmitting = false;
      });
    }

    collectFormData() {
      return {
        category: this.categoryInput?.value || '',
        name: this.form.querySelector('[name="contact[name]"]')?.value || '',
        email: this.form.querySelector('[name="contact[email]"]')?.value || '',
        phone: this.form.querySelector('[name="contact[phone]"]')?.value || '',
        subject: this.form.querySelector('[name="contact[subject]"]')?.value || '',
        message: this.form.querySelector('[name="contact[body]"]')?.value || '',
      };
    }

    syncCategoryWithSelectedTab() {
      const selectedTab = this.querySelector('.contact-form-tabs__tab[aria-selected="true"]');
      if (selectedTab && this.categoryInput) {
        this.categoryInput.value = selectedTab.dataset.category || '';
      }
    }

    getMessageElement(type) {
      return this.querySelector(`.contact-form-tabs__message--${type}`);
    }

    clearMessages() {
      ['success', 'error'].forEach((type) => {
        const message = this.getMessageElement(type);
        if (message) {
          message.hidden = true;
        }
      });
    }

    showMessage(type) {
      this.clearMessages();
      const message = this.getMessageElement(type);
      if (message) {
        message.hidden = false;
        message.setAttribute('tabindex', '-1');
        message.focus();
      }
    }

    async submitToAPI(data) {
      const body = JSON.stringify(data);

      try {
        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), 8000);
        const response = await fetch(this.API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body,
          keepalive: true,
          signal: controller.signal,
        });
        window.clearTimeout(timeoutId);
        return response.ok;
      } catch (error) {
        console.error('API submission error:', error);
        return false;
      }
    }
  }

  if (!customElements.get('contact-form-tabs')) {
    customElements.define('contact-form-tabs', ContactFormTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collection-slider"] && !Shopify.designMode) return;
  try {
    
  class ProductCollectionSliderComponent extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
    }

    connectedCallback() {
      this.slider = this.querySelector('[data-slider]');
      this.slides = this.querySelectorAll('.product-collection-slider__slide');
      this.dots = this.querySelectorAll('.product-collection-slider__dot');

      this.setupMobileSlider();
    }

    setupMobileSlider() {
      if (!this.slider) return;

      let scrollTimeout;
      this.slider.addEventListener(
        'scroll',
        () => {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => {
            this.updateMobileState();
          }, 50);
        },
        { passive: true }
      );

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.scrollToSlide(index);
        });
      });
    }

    updateMobileState() {
      if (!this.slider || !this.slides.length) return;

      const sliderRect = this.slider.getBoundingClientRect();
      const sliderCenter = sliderRect.left + sliderRect.width / 2;

      let closestIndex = 0;
      let closestDistance = Infinity;

      this.slides.forEach((slide, index) => {
        const slideRect = slide.getBoundingClientRect();
        const slideCenter = slideRect.left + slideRect.width / 2;
        const distance = Math.abs(slideCenter - sliderCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      if (closestIndex !== this.currentIndex) {
        this.currentIndex = closestIndex;
        this.updateDots(closestIndex);
      }
    }

    updateDots(activeIndex) {
      this.dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    scrollToSlide(index) {
      if (!this.slides[index] || !this.slider) return;

      const slide = this.slides[index];
      const sliderRect = this.slider.getBoundingClientRect();
      const slideRect = slide.getBoundingClientRect();

      const scrollLeft =
        this.slider.scrollLeft + (slideRect.left - sliderRect.left) - (sliderRect.width - slideRect.width) / 2;

      this.slider.scrollTo({
        left: scrollLeft,
        behavior: 'smooth',
      });

      this.currentIndex = index;
      this.updateDots(index);
    }
  }

  if (!customElements.get('product-collection-slider-component')) {
    customElements.define('product-collection-slider-component', ProductCollectionSliderComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solution-tabs"] && !Shopify.designMode) return;
  try {
    
  class SolutionTabsComponent extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll('.solution-tabs__tab');
      this.panels = this.querySelectorAll('.solution-tabs__panel');
      this.slider = this.querySelector('[data-slider]');
      this.slides = this.querySelectorAll('.solution-tabs__slide');
      this.dots = this.querySelectorAll('.solution-tabs__dot');
      this.mobileTitle = this.querySelector('[data-mobile-title]');
      this.titles = Array.from(this.slides).map((slide) => {
        const block = slide.closest('[data-slide-index]');
        const index = parseInt(block?.dataset.slideIndex || '0', 10);
        const tab = this.tabs[index];
        return tab?.textContent?.trim() || '';
      });

      this.setupDesktopTabs();
      this.setupMobileSlider();
    }

    setupDesktopTabs() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectTab(index));

        tab.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
            e.preventDefault();
            const nextIndex = (index + 1) % this.tabs.length;
            this.selectTab(nextIndex);
            this.tabs[nextIndex].focus();
          } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
            e.preventDefault();
            const prevIndex = (index - 1 + this.tabs.length) % this.tabs.length;
            this.selectTab(prevIndex);
            this.tabs[prevIndex].focus();
          }
        });
      });
    }

    selectTab(index) {
      this.tabs.forEach((tab, i) => {
        const isSelected = i === index;
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');
      });

      this.panels.forEach((panel, i) => {
        if (i === index) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      this.currentIndex = index;
    }

    setupMobileSlider() {
      if (!this.slider) return;

      let scrollTimeout;
      this.slider.addEventListener(
        'scroll',
        () => {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => {
            this.updateMobileState();
          }, 50);
        },
        { passive: true }
      );

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.scrollToSlide(index);
        });
      });
    }

    updateMobileState() {
      if (!this.slider || !this.slides.length) return;

      const sliderRect = this.slider.getBoundingClientRect();
      const sliderCenter = sliderRect.left + sliderRect.width / 2;

      let closestIndex = 0;
      let closestDistance = Infinity;

      this.slides.forEach((slide, index) => {
        const slideRect = slide.getBoundingClientRect();
        const slideCenter = slideRect.left + slideRect.width / 2;
        const distance = Math.abs(slideCenter - sliderCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      if (closestIndex !== this.currentIndex) {
        this.currentIndex = closestIndex;
        this.updateDots(closestIndex);
        this.updateMobileTitle(closestIndex);
      }
    }

    updateDots(activeIndex) {
      this.dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    updateMobileTitle(index) {
      if (this.mobileTitle && this.titles[index]) {
        this.mobileTitle.textContent = this.titles[index];
      }
    }

    scrollToSlide(index) {
      if (!this.slides[index] || !this.slider) return;

      const slide = this.slides[index];
      const sliderRect = this.slider.getBoundingClientRect();
      const slideRect = slide.getBoundingClientRect();

      const scrollLeft =
        this.slider.scrollLeft + (slideRect.left - sliderRect.left) - (sliderRect.width - slideRect.width) / 2;

      this.slider.scrollTo({
        left: scrollLeft,
        behavior: 'smooth',
      });

      this.currentIndex = index;
      this.updateDots(index);
      this.updateMobileTitle(index);
    }
  }

  if (!customElements.get('solution-tabs-component')) {
    customElements.define('solution-tabs-component', SolutionTabsComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specifications"] && !Shopify.designMode) return;
  try {
    
  class SpecificationsScrollProgress extends HTMLElement {
    constructor() {
      super();
      this.scrollContent = this.querySelector('[data-scroll-content]');
      this.progressBar = this.querySelector('[data-progress-bar]');
    }

    connectedCallback() {
      if (!this.scrollContent || !this.progressBar) return;

      this.updateProgress();

      this.scrollContent.addEventListener(
        'scroll',
        () => {
          this.updateProgress();
        },
        { passive: true }
      );

      const resizeObserver = new ResizeObserver(() => {
        this.updateProgress();
      });
      resizeObserver.observe(this.scrollContent);
    }

    updateProgress() {
      const { scrollTop, scrollHeight, clientHeight } = this.scrollContent;
      const scrollableHeight = scrollHeight - clientHeight;

      if (scrollableHeight <= 0) {
        this.progressBar.style.height = '100%';
        return;
      }

      const progress = (scrollTop / scrollableHeight) * 100;
      this.progressBar.style.height = `${Math.min(100, Math.max(0, progress))}%`;
    }
  }

  if (!customElements.get('specifications-scroll-progress')) {
    customElements.define('specifications-scroll-progress', SpecificationsScrollProgress);
  }

  } catch(e) { console.error(e); }
})();
})();
